module.exports = __webpack_public_path__ + "img/historia13.9cbb4563.jpg";